const url = '/clients';
const Provider = 'Clients';
const dbModel = 'Clients';

export { url, Provider, dbModel };
